import React, { useEffect, useRef, useState } from "react";
import BaseRoutes from "./routes/index.js";
import "./App.scss";
import {
  selectAuthData,
} from "./core/store/redux/slices/Auth-slice.js";
import { useNavigate } from "react-router-dom";
import { selectPermissions } from "./core/store/redux/slices/Permission-slice.js";
import { resolveLandingRoute } from "./core/permissions";
import { getDataFromDB } from "./db/dbHelpers.js";
import { useSelector } from "react-redux";
import * as faceapi from "face-api.js";
import Loader from "./components/loader/Loader.jsx";
import useUserDetails from "./hooks/useUserDetails.js";
import useNetworkStatus from "./hooks/useNetworkStatus.js";
import useAppConfig from "./hooks/useAppConfig.js";
import UpdateBanner from "./components/version/UpdateBanner.jsx";
import MaintenancePage from "./components/version/MaintenancePage.jsx";
import AnnouncementBanner from "./components/version/AnnouncementBanner.jsx";

function App() {
  const authData = useSelector(selectAuthData);
  const { isOnline } = useNetworkStatus();
  const navigate = useNavigate();
  const wasOffline = useRef(false);
  const [offlineData, setOfflineData] = useState(null);

  useEffect(() => {
    if (!isOnline) {
      const fetchOfflineData = async () => {
        const data = await getDataFromDB("credentials");
        setOfflineData(data);
      };
      fetchOfflineData();
    }
  }, [isOnline]);

  const permissions = useSelector(selectPermissions);
  const { role_code } = (isOnline ? authData?.user : offlineData?.user) ?? {};
  const is_trial =
    (isOnline ? authData?.is_trial : offlineData?.is_trial) ?? {};

  const landingRoute = resolveLandingRoute(permissions, role_code, is_trial, isOnline);

  useEffect(() => {
    const fetchOfflineData = async () => {
      const data = await getDataFromDB("credentials");
      setOfflineData(data);
    };
    if (!isOnline) {
      wasOffline.current = true;
      navigate("/main/offline", { replace: true });
      fetchOfflineData();
    } else if (wasOffline.current) {
      navigate(landingRoute, { replace: true });
      wasOffline.current = false;
    }
  }, [isOnline, landingRoute]);

  const { loading } = useUserDetails();
  const appConfig = useAppConfig();

  //Face Model
  useEffect(() => {
    const loadModels = async () => {
      try {
        const MODEL_URL = 'https://cdn.jsdelivr.net/gh/justadudewhohacks/face-api.js@master/weights';
        await Promise.all([
          faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
          faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
          faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
        ]);
        console.log("Face-API models loaded successfully");
      } catch (err) {
        console.error("Failed to load Face-API models", err);
      }
    };
    loadModels();
  }, []);


  if (appConfig?.maintenance?.active) {
    return (
      <MaintenancePage
        message={appConfig.maintenance.message}
        contact={appConfig.maintenance.contact}
      />
    );
  }

  return loading ? (
    <Loader />
  ) : (
    <>
      {appConfig?.announcement?.active && appConfig.announcement.message && (
        <AnnouncementBanner
          message={appConfig.announcement.message}
          type={appConfig.announcement.type}
        />
      )}
      <BaseRoutes />
      <UpdateBanner />
    </>
  );
}

export default App;
